import React from 'react';
import styles from './index.module.scss';
import not_found from '../../../../assets/images/not_found.png';
import bank_logo from '../../../../assets/images/bank_logo.png';
import UPI from '../../../../assets/images/UPI.png';
import bankName from '../../../../assets/images/bankName.png';

function URLNotFound({ setOpen }) {
  return (
    <div className={styles.notFoundContainer}>
      <img src={not_found} alt={'url not found'} />
      <div className={styles.header}>Oops! URL not found</div>
      <div className={styles.subHeader}>
        We couldn’t find the Redirection URL for this brand
      </div>
      <button className={styles.button} onClick={() => setOpen(false)}>
        OKAY
      </button>
      <div className={styles.footer}>
        <div>
          <img src={bank_logo} alt="bank_logo" />
          <img src={bankName} alt="bank_name" />
        </div>
        <div className={styles.dot}></div>
        <div>
          <div className={styles.poweredBy}>POWERED BY</div>
          <img src={UPI} alt="upi" />
        </div>
      </div>
    </div>
  );
}

export default React.memo(URLNotFound);
